import { FormattedMessage } from "react-intl";
import { SharedItemLinks } from "./DocumentDeleteConflictAlert";

export interface KeptDocument {
  id: string;
  name: string;
  reason: string | { sharedItemIds: string[] };
}

export function FolderDeleteReport({ id, deleted, kept }: { id?: string; deleted: number; kept: readonly KeptDocument[] }) {
  return (
    <div id={id} className="mt-3 text-smycles-label text-red-600" role="alert">
      <FormattedMessage
        id="service.page.folderDeleteIncomplete"
        defaultMessage="{deleted, plural, =0 {No document deleted} one {# document deleted} other {# documents deleted}}, {kept, plural, other {# could not be deleted}}, so the folder stays."
        values={{ deleted, kept: kept.length }}
      />
      <ul className="mt-1 flex flex-col gap-1">
        {kept.map(document => {
          const keptId = id && `${id}-kept-${document.id}`;
          return (
            <li key={document.id} id={keptId}>
              <span className="font-medium">{document.name}</span>
              {": "}
              {typeof document.reason === "string" ? document.reason : (
                <>
                  <FormattedMessage
                    id="service.page.folderDeleteKeptShared"
                    defaultMessage="still used in shared posts. Remove it there first:"
                  />
                  <SharedItemLinks id={keptId} className="mt-0.5" sharedItemIds={document.reason.sharedItemIds} />
                </>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
